// extracted by mini-css-extract-plugin
export default {"tooltip":"sU-z","arrow":"tU-z"};